import type {
  Rooms_GetRoomsInfo_GetRoomsInfoQueryResponse_Success,
  Rooms_Info_RoomInfo,
} from "../../swagger-types/v1/index.js";
import { getFallbackImageUrl } from "../image-fixtures.js";

const roomImageUrl = getFallbackImageUrl();

const createRoomInfo = ({
  bed,
  view,
  amenity,
  squareMeters,
}: {
  bed: string;
  view: string;
  amenity: string;
  squareMeters: number;
}): Rooms_Info_RoomInfo => ({
  beds: [{ id: 1, description: bed }],
  views: [{ name: view }],
  images: [
    {
      smallImageUrl: roomImageUrl,
      mediumImageUrl: roomImageUrl,
      largeImageUrl: roomImageUrl,
      ordinal: 1,
      caption: "Room",
      main: true,
    },
  ],
  amenities: [
    {
      id: 1,
      name: amenity,
      value: null,
      categories: ["Room"],
    },
  ],
  descriptionObject: {
    en: "A room with a king bed.",
  },
  maxAdults: 2,
  maxChildren: 1,
  minAdultAge: 18,
  minChildAge: 0,
  minInfantAge: 0,
  squareFeet: 320,
  squareMeters,
});

export const roomsInfoResponseFake: Rooms_GetRoomsInfo_GetRoomsInfoQueryResponse_Success = {
  rooms: [
    {
      roomId: 101,
      name: "Deluxe King Room",
      info: createRoomInfo({
        bed: "King bed",
        view: "City view",
        amenity: "Air conditioning",
        squareMeters: 29.73,
      }),
    },
    {
      roomId: 202,
      name: "Deluxe Room",
      info: createRoomInfo({
        bed: "Queen bed",
        view: "Garden view",
        amenity: "Free WiFi",
        squareMeters: 28,
      }),
    },
    {
      roomId: 303,
      name: "Standard Double Bed Room",
      info: createRoomInfo({
        bed: "2 double beds",
        view: "Courtyard view",
        amenity: "Flat-screen TV",
        squareMeters: 32,
      }),
    },
  ],
};

export const roomsInfoResponseWithoutInfoFake: Rooms_GetRoomsInfo_GetRoomsInfoQueryResponse_Success = {
  rooms: [
    {
      roomId: 202,
      name: "Room without details",
      info: null,
    },
  ],
};

export const emptyRoomInfo: Rooms_Info_RoomInfo = {
  beds: [],
  views: [],
  images: [],
  amenities: [],
  descriptionObject: {},
  squareFeet: null,
  squareMeters: null,
};
